import isNumber from './is-number';
/**
 * 判断值是否为负数
 * @return 是否为负数
 */
export default function isNegative(num) {
    return isNumber(num) && num < 0;
}
//# sourceMappingURL=is-negative.js.map